import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* createOrUpdateCategory() {
    yield takeEvery(actions.CREATE_OR_UPDATE_CATEGORY_REQUESTED, function* (action) {
        try {
            const category = yield call(actions.createOrUpdateCategory, action.payload);
            yield put({ type: actions.CREATE_OR_UPDATE_CATEGORY_SUCCEEDED, category });
        } catch (error) {
            yield put({ type: actions.CREATE_OR_UPDATE_CATEGORY_FAILED, error: error.response.data });
        }
    });
}
export default function* rootSaga() {
  yield all([
    fork(createOrUpdateCategory)
  ]);
}
